<template>
    <div class="PersonalProfile safe-distance-top">
        <div class="PersonalProfile_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">个人简历</div>
            <div class="determine" @click="determine">确定</div>
        </div>
        <div class="PersonalProfile_bottom">
            <van-field
                v-model="profile"
                rows="2"
                autosize
                type="textarea"
                maxlength="500"
                placeholder="请输入个人简历"
                show-word-limit
                ref="input"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "PersonalProfile",
    data() {
        return {
            profile: "",
            obj: {},
        };
    },
    mounted() {
        this.obj = JSON.parse(sessionStorage.getItem("scholarUserInfos"));
        this.profile = JSON.parse(sessionStorage.getItem("scholarUserInfos")).userInfo.profile;
        // 聚焦
        this.$nextTick(() => {
            this.$refs.input.focus();
        });
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        determine() {
            if (this.profile.length == 0) {
                Toast("不能为空");
            } else {
                this.obj.userInfo.profile = this.profile;

                sessionStorage.setItem("scholarUserInfos", JSON.stringify(this.obj));

                this.$router.push("information");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.PersonalProfile {
    width: 100vw;
    min-height: 100vh;
    background: #f5f5f5;
    overflow: hidden;

    .PersonalProfile_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            text-align: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .PersonalProfile_bottom {
        width: 94%;
        margin: 12px auto;
        border-radius: 8px;

        .van-field {
            border-radius: 8px;
        }
    }
}
</style>
